<div class="{{ colorScheme().backgroundClass }} px-4 py-12px">
  <div class="row">
    <div class="col">
      <div class="row flex-nowrap gx-2 justify-content-center">
        <div class="col-auto">
          @if (iconClass()) {
            <i class="fas {{ iconClass() }} {{ colorScheme().iconColorClass }}" aria-hidden="true" style="font-size: 1.5rem"></i>
          } @else {
            <i
              class="fas {{ colorScheme().iconClass }} {{ colorScheme().iconColorClass }}"
              aria-hidden="true"
              style="font-size: 1.5rem"
            ></i>
          }
        </div>
        <div class="col-auto align-self-center">
          <div class="" [ngClass]="colorScheme().textColorClass" [attr.title]="text() | translate">
            @if (text()) {
              <span [innerHTML]="text() | translate | safeHtml"></span>
            } @else {
              <span>
                <ng-content />
              </span>
            }
          </div>
        </div>
      </div>
    </div>
    @if (isClosable()) {
      <div class="col-auto">
        <div class="col-auto">
          <mwe-button
            title="Schließen"
            category="tertiary"
            [color]="colorScheme().closeBtnColor || 'white'"
            type="button"
            (clicked)="close()"
            size="sm"
            prependIconClass=""
            [isIconBtn]="true"
          >
            <i class="fas fa-times" aria-hidden="true"></i>
          </mwe-button>
        </div>
      </div>
    }
  </div>
</div>
